export default "__VITE_ASSET__CT5u9VtX__"